import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";

/**
 * Formats the given price with JS Intl NumberFormat API.
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat)
 * @param {Number|String} price - Price to be formatted.
 * @param {String} locale - Locale code for formatting.
 * @param {String} currency - Currency
 * @param {Object} options - Additional options for options object of Intl API.
 * @return {String} Formatted price.
 */
export var formatPrice = function formatPrice(price) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'USD';
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Intl.NumberFormat(locale, _objectSpread({
    currency: currency,
    style: 'currency',
    minimumFractionDigits: 0
  }, options)).format(price);
};
/**
 * @param {Number|String} price - Price to be formatted.
 * @param {String} locale - Locale code for formatting.
 * @param {Object} options - Additional options for options object of Intl API.
 * @return {String} Formatted price with no currency symbol : input :12000 output :12,000.
 */

export var formatPriceNoCurrencySymbol = function formatPriceNoCurrencySymbol(price) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Intl.NumberFormat(locale, _objectSpread({
    minimumFractionDigits: 0
  }, options)).format(price);
};
/**
 * Formats the given prices as range, using the formatPrice function.
 * @param {Number|String} fromPrice - From price to be formatted.
 * @param {Number|String} toPrice - To price to be formatted.
 * @param {String} locale - Locale code for formatting.
 * @param {String} currency - Currency
 * @param {Object} options - Additional options for options object of Intl API.
 * @return {String} Formatted price range.
 */

export var formatPriceRange = function formatPriceRange(fromPrice, toPrice) {
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'USD';
  var formattedFromPrice = "".concat(formatPriceNoCurrencySymbol(fromPrice));
  var formattedToPrice = "".concat(formatPriceNoCurrencySymbol(toPrice));

  if (fromPrice && toPrice) {
    return "".concat(currency, " ").concat(formattedFromPrice, " - ").concat(formattedToPrice);
  } else if (fromPrice) {
    return "> ".concat(currency, " ").concat(formattedFromPrice);
  } else if (toPrice) {
    return "< ".concat(currency, " ").concat(formattedToPrice);
  }

  return null;
};
export default {};